<template>
    <div class='mian boxShadow'>
        <div class="main-item">
            <div class="flex ">
                <p class="mian-item-title ">职位类型</p>
                <div class="flex mian-item-label">
                    <p :class="formData.positionKind===''?'active':''" @click="handleChange('positionKind','')">不限</p>
                    <p :class="formData.positionKind===item.positionType?'active':''" 
                    v-for="item in companyJobs" :key="item.positionType"
                    @click="handleChange('positionKind',item.positionType)">
                        {{ item.positionTypeName }}
                    </p>
                </div>
            </div>
        </div>

        <div class="flex">
            <el-select 
                v-model="formData.cityCode" size="small" clearable 
                placeholder="工作城市" 
                @change="handleChange('cityCode',formData.cityCode )" 
                @clear="clearSelectOption('cityCode')">
                <el-option
                    v-for="item in this.positionArea"
                    :key="item.cityCode"
                    :label="item.cityName"
                    :value="item.cityCode">
                </el-option>
            </el-select>
            
            <el-select 
                v-model="formData.workExperience" size="small" clearable 
                placeholder="工作经验" 
                @change="handleChange('workExperience',formData.workExperience)" 
                @clear="clearSelectOption('workExperience')">
                <el-option
                    v-for="item in this.workExperienceType"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>

            <el-select 
                v-model="formData.qualificationsType" size="small" clearable 
                placeholder="学历要求" 
                @change="handleChange('qualificationsType',formData.qualificationsType)" 
                @clear="clearSelectOption('qualificationsType')">
                <el-option
                    v-for="item in this.qualificationsType"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>
            <div class="flex main-company-search">
                <el-input 
                 suffix-icon="el-icon-search" 
                 v-model="formData.name" 
                 placeholder="职位关键字" 
                 size="small"
                 @blur="handleBlure">
                </el-input>
            </div>
            
        </div>

    </div>
  </template>
  
  <script>
  import { mapGetters,mapActions,mapState } from "vuex";
  export default {
    props: {
        
    },
    data() {
        return {         
           formData:{  //表单数据
             cityCode:"",//城市编码
             workExperience:"",//工作经验
             qualificationsType:'', //学历要求
             name:'',
             positionKind:"",
           },
           
        };
    },
    components: {
    },
   
    computed: {
     
      ...mapGetters([
         "qualificationsType",//学历要求
         "industryType",//企业行业类型
         "positionType",//职位类型
         "scale",       //公司规模
         "financingType",//融资情况
         "companyType", //公司类型
         "workExperienceType",//工作经验
      ]),
    
      ...mapState({
        positionArea:state => state.jobs.positionArea,
        companyJobs:state => state.company.companyJobs,

      })
    },
    methods: {
        ...mapActions([
            
        ]),
        //在招公司查询条件选择
        handleChange(key,value){
            this.formData[key] = value;
            this.$emit('updateFormData',this.formData)
        },
        clearSelectOption(key){
            this.formData[key] = '';
            this.$emit('updateFormData',this.formData)
        },
        handleBlure(value){
            this.$emit('updateFormData',this.formData)
        }

    
    }
  };
  </script>
  
  <style lang="less" scoped>
  @mianColor:#287CF3;
  @whiteColor:#fff;
  @mainFontCol:rgba(0,0,0,0.85);
  @secondfontCol:rgba(0,0,0,0.5);
  .mian{
    background: @whiteColor;
    padding: 10px 24px 30px ;
    // margin: 30px 0;
    .has-border{
        border-bottom: 1px solid rgba(0, 0, 0, 0.10);
    }
    &-item{
       align-items: flex-start;
       color:@mainFontCol;
       transition: all .2s linear;
       padding: 10px 0;
       .el-select{
        padding:8px  20px 8px 0; 
       }

       &-title{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        padding:8px  30px 8px 0; 
        flex-shrink: 0;
       }
       &-clear{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.25);
        padding:8px  30px 8px 0; 
        align-self: flex-end;
        cursor: pointer;
        &:hover{
            color: @mianColor;
        }
       }
       &-label{
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        flex-wrap: wrap;
        align-items: center;
            p{
                padding:8px  20px 8px 0; 
                cursor: pointer;
            }
            .active{
                color: @mianColor;
            }
            &-text{
                padding: 0 4px;
            }
            &-input{
                align-items: center;
                transition: all .3s linear;
                flex-wrap: nowrap;
                &:hover{
                    background: #FFFFFF;
                    padding: 8px 10px;
                    box-shadow: 0 1px 17px 1px rgba(22, 9, 6, 0.2);
                    border-radius: 6px;
                    .el-button{
                        display: block;
                    }

                }
                .el-button{
                    margin-left: 10px;
                    display: none;
                }
                .el-button--primary {
                    color: #FFF;
                    background-color: @mianColor;
                    border-color: @mianColor;
                }
            }
       }
       .subarea{
        background: #f8f8f8;
        padding: 0 12px;
        border-radius: 4px;
        margin: 4px 0;
        transition: all .2s linear;
        .hasBorder{
            border-top: 1px solid #ececec;
            font-size: 14px;
        }
       }

    }
    .main-company-search{
        align-items: center;
        margin-top: 10px;
        &-btns{
           margin-left: 2px;
           cursor: pointer;

        }
    }
  }


  .collect-action {
    margin-left: 3px;
    color: #049cfd;
    cursor: pointer;
    font-size: 14px;
  }
  .el-select{
    margin-right: 24px;
    margin-top: 10px;
  }
  </style>
  